import { render, staticRenderFns } from "./xs_PerformanceStatistics_db.vue?vue&type=template&id=cb9a42c6"
import script from "./xs_PerformanceStatistics_db.vue?vue&type=script&lang=js"
export * from "./xs_PerformanceStatistics_db.vue?vue&type=script&lang=js"
import style0 from "./xs_PerformanceStatistics_db.vue?vue&type=style&index=0&id=cb9a42c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports